module.exports = __webpack_public_path__ + "img/input.a120d230.png";